import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {UserService} from '../services/user.service';
import {AuthService} from '../services/auth.service';
import {ToastService} from '../services/toast.service';
import {hasAppAccess} from '../models/user.model';

export const isSignedInGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const userService = inject(UserService);
  const router = inject(Router);
  const toastService = inject(ToastService);

  // Fetch all information about the user/Tenant
  await authService.fetch();

  const isLoggedIn = userService.isLoggedIn();
  const user = userService.getUser();

  if (!isLoggedIn) {
    userService.setPostSignInPage(state.url);
    return router.createUrlTree(['/auth/login']);
  }

  // Check app access (DownloadOnly users are not allowed)
  if (user && hasAppAccess(user.userAccessLevel)) {
    // Only fetch additional data when user has app access
    authService.fetchPayrollProviders();
    return true;
  }

  // DownloadOnly users are not allowed to access the app
  toastService.showWarning('auth.noAppAccess');
  await authService.logout();
  return router.createUrlTree(['/auth/login']);
};
